import { createHelpers } from "vuex-map-fields";
import { httpError } from "@/models/httpError";
import { getField, updateField } from "vuex-map-fields";

export const { mapFields: mapMessageFields } = createHelpers({
  getterType: `message/getField`,
  mutationType: `message/updateField`
});

const state = {
  message: new httpError()
};

const actions = {
  reset({ commit }) {
    commit("clearProgress");
  },
  setMessage({ commit }, message) {
    commit("setProgress", message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit("setProgress", new httpError());
      }, 2000);
  }
};

const mutations = {
  setProgress(state, message) {
    state.message = message;
  },
  clearProgress(state) {
    state.message = new httpError();
  },
  updateField
};

const getters = {
  getField
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
